import I18nForLwText from './LwText'

export default class I18nForLwSwitch extends I18nForLwText {
  name = 'lw-switch'
}
